/*
  aw-audio — behaviour for snippets/aw-audio.liquid, 27 Sep.

  Each player loads this file with defer, so it can run more than once on a
  page; the first run binds every player and later runs stop at the guard.
  The theme editor re-renders a section without reloading, hence the
  shopify:section:load listener.

  The native controls are the no-JavaScript floor: binding turns them off and
  shows the custom row. A file that cannot load hides the whole player.
*/
(function () {
  if (window.awAudioReady) return;
  window.awAudioReady = true;

  function clock(seconds) {
    if (!isFinite(seconds) || seconds < 0) return '';
    var whole = Math.floor(seconds);
    return Math.floor(whole / 60) + ':' + ('0' + (whole % 60)).slice(-2);
  }

  function bind(root) {
    var media = root.querySelector('audio');
    var ui = root.querySelector('.aw-audio__ui');
    var toggle = root.querySelector('[data-aw-audio-toggle]');
    var seek = root.querySelector('[data-aw-audio-seek]');
    var time = root.querySelector('[data-aw-audio-time]');
    if (!media || !ui || !toggle || !seek || !time) return;

    if (media.error) {
      root.hidden = true;
      return;
    }

    function paint() {
      var total = media.duration;
      var now = media.currentTime;
      var share = total > 0 ? Math.min(now / total, 1) : 0;
      seek.value = Math.round(share * 1000);
      seek.style.setProperty('--aw-audio-progress', (share * 100).toFixed(2) + '%');
      var totalText = clock(total);
      time.textContent = now > 0 && totalText ? clock(now) + ' / ' + totalText : totalText;
      seek.setAttribute('aria-valuetext', totalText ? clock(now) + ' of ' + totalText : clock(now));
    }

    function mark(playing) {
      root.setAttribute('data-state', playing ? 'playing' : 'paused');
      toggle.setAttribute('aria-label', playing ? root.dataset.pauseLabel : root.dataset.playLabel);
    }

    toggle.addEventListener('click', function () {
      if (media.paused) {
        var attempt = media.play();
        if (attempt && attempt.catch) attempt.catch(function () {});
      } else {
        media.pause();
      }
    });

    seek.addEventListener('input', function () {
      if (media.duration > 0) media.currentTime = (seek.value / 1000) * media.duration;
      paint();
    });

    // One demo at a time: starting this one stops any other on the page.
    media.addEventListener('play', function () {
      document.querySelectorAll('[data-aw-audio] audio').forEach(function (other) {
        if (other !== media && !other.paused) other.pause();
      });
      mark(true);
    });
    media.addEventListener('pause', function () { mark(false); });
    media.addEventListener('ended', function () {
      media.currentTime = 0;
      mark(false);
      paint();
    });
    media.addEventListener('timeupdate', paint);
    media.addEventListener('loadedmetadata', paint);
    media.addEventListener('durationchange', paint);
    media.addEventListener('error', function () {
      media.pause();
      root.hidden = true;
    });

    media.controls = false;
    ui.hidden = false;
    mark(false);
    paint();
  }

  function init() {
    document.querySelectorAll('[data-aw-audio]').forEach(function (root) {
      if (root.dataset.awBound === 'true') return;
      root.dataset.awBound = 'true';
      bind(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
